import PropTypes from 'prop-types';

export function trackAdobeEvent(event, otherData = {}) {
  window?.pageDataTracker?.trackEvent?.(event, { ...otherData });
}

export function trackAdobeFeature(name) {
  window?.pageDataTracker?.trackEvent?.('productFeatureUsed', { feature: { name } });
}

export function trackAdobeWidgetImpression(widgetNames) {
  window?.pageDataTracker?.trackEvent('widgetImpression', { link: { widgetNames } });
}

export function createUsageEventData(id, type, format, detail) {
  const content = { id, type, format };
  if (detail) {
    content.detail = detail;
  }

  return { content: [content] };
}

export const UsageEventDataPropTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.shape({
        id: PropTypes.string,
        type: PropTypes.string,
        format: PropTypes.string,
        detail: PropTypes.string,
      }),
    }),
  ),
};

export function createNavigationClickEventData(location, name) {
  return { link: { location, name } };
}

export const NavigationClickEventDataPropTypes = {
  link: PropTypes.shape({
    location: PropTypes.string,
    name: PropTypes.string,
  }),
};

export function trackContentDownload(id, type, format, detail) {
  trackAdobeEvent('contentDownload', createUsageEventData(id, type, format, detail));
}

export function trackNavigationClick(location, name) {
  trackAdobeEvent('navigationClick', createNavigationClickEventData(location, name));
}

export const analyticsFormat = {
  MIME_PDF: 'mime-pdf',
  MIME_HTML: 'mime-html',
  MIME_XHTML: 'mime-xhtml',
};

export const analyticsScope = {
  ABSTRACT: 'scope-abstract',
  CARD: 'scope-card',
  FULL: 'scope-full',
};
